import RemoveBgBulkModal from "./RemoveBgBulkModal";

export default RemoveBgBulkModal;
